import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tdsFilter'
})

export class TdsFilterPipe implements PipeTransform {

  // transform(list: any[], filterText: string): any {
  //   return list ? list.filter(item => item.name.search(new RegExp(filterText, 'i')) > -1) : [];
  // }
  transform(Masterlist : any[], searchTerm: string): any[]{
     if(!Masterlist || !searchTerm)
    {
        return Masterlist
    }
    return Masterlist.filter(master =>
        this.formattedDate(master.createdDate).indexOf(searchTerm.toLowerCase()) !== -1 ||
        master.quarter.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 ||
        master.financialYear.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 ||
        master.tdsCode.toString().indexOf(searchTerm.toString()) !== -1 ||
        master.filePath.toString().indexOf(searchTerm.toString()) !== -1     
    );

    }

    formattedDate(d:any) {

      d = new Date(d);
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());
    
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
    
      return `${day}-${month}-${year}`;
    }
}
